import styled from "styled-components";

// The Feature Flags console's wrappers, so both admin consoles look alike.
export const ConsoleLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ConsoleCard = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 49, 0.05);
  padding: 32px;
`;

export const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 16px;
`;
